import { Compass, Telescope } from "lucide-react";
import { MISION, VISION } from "../lib/content";

export default function MissionVision() {
  return (
    <section
      id="mision-vision"
      data-testid="mision-vision-section"
      className="relative w-full"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Misión - dark */}
        <div
          data-testid="mision-block"
          className="relative bg-[var(--ms-ink)] text-white px-6 md:px-12 lg:px-16 py-24 md:py-32 overflow-hidden grain"
        >
          <div className="pointer-events-none absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full blur-3xl opacity-30"
               style={{ background: "radial-gradient(circle, #7030A0 0%, transparent 70%)" }} />

          <div className="relative max-w-xl ml-auto lg:ml-0 lg:mr-auto">
            <div className="flex items-center gap-3 mb-8">
              <Compass size={18} className="text-[var(--ms-lila)]" />
              <span className="font-body uppercase text-[11px] tracking-[0.32em] text-[var(--ms-lila)]">
                02 / Misión
              </span>
            </div>

            <h3 className="font-display font-medium text-5xl md:text-6xl tracking-tight mb-8">
              <span className="text-white/40">La</span> Misión
            </h3>

            <p className="font-editorial text-2xl md:text-3xl leading-[1.35] text-white/90">
              {MISION}
            </p>

            <div className="mt-10 inline-flex items-center gap-3 px-4 py-2 rounded-full border border-white/15">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--ms-lila)] animate-pulse" />
              <span className="font-body text-[12px] tracking-wider text-white/70 uppercase">
                Alto Impacto · Comunicación Efectiva
              </span>
            </div>
          </div>
        </div>

        {/* Visión - light */}
        <div
          data-testid="vision-block"
          className="relative bg-[#FCFAFF] text-[var(--ms-ink)] px-6 md:px-12 lg:px-16 py-24 md:py-32 overflow-hidden"
        >
          {/* Background image */}
          <img
            src="https://customer-assets.emergentagent.com/job_sublime-landing/artifacts/cn3901dj_mision.webp"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          {/* Cream gradient: keeps left side legible, lets megaphone breathe on right */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#FCFAFF] via-[#FCFAFF]/88 to-[#FCFAFF]/15 lg:to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#FCFAFF]/60 via-transparent to-[#FCFAFF]/40" />

          <div className="relative max-w-xl">
            <div className="flex items-center gap-3 mb-8">
              <Telescope size={18} className="text-[var(--ms-purple)]" />
              <span className="font-body uppercase text-[11px] tracking-[0.32em] text-[var(--ms-purple)] font-bold">
                03 / Visión
              </span>
            </div>

            <h3 className="font-display font-medium text-5xl md:text-6xl tracking-tight mb-8">
              <span className="text-[var(--ms-gray)]/60">La</span> Visión
            </h3>

            <p className="font-editorial text-2xl md:text-3xl leading-[1.35] text-[var(--ms-ink)]">
              {VISION}
            </p>

            <div className="mt-10 inline-flex items-center gap-3 px-4 py-2 rounded-full bg-[var(--ms-purple)]/10 border border-[var(--ms-purple)]/20 backdrop-blur-sm">
              <span className="font-display font-semibold text-[12px] tracking-wider text-[var(--ms-purple)]">
                2030 · Excelencia Internacional
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
